var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.app)?_c('div',{staticClass:"view--settings"},[_c('app-settings-header',{attrs:{"app":_vm.app}}),_c('app-settings-content',{attrs:{"app":_vm.app}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }